function sanitizeNestedItems(items = []) {
  return items.map(({ _key, ...item }) => item);
}

export function buildStepFormData(step = {}) {
  return {
    step: {
      name: step.name || "",
      description: step.description || "",
      index: step.index ?? 0,
      completion_criteria: step.completion_criteria || "",
      step_templates_attributes: step.step_templates_attributes || [],
      sub_steps_attributes: step.sub_steps_attributes || [],
      step_participants_attributes: step.step_participants_attributes || []
    }
  };
}

export function serializeStep(step) {
  return {
    ...step,
    step_templates_attributes: sanitizeNestedItems(step.step_templates_attributes),
    sub_steps_attributes: sanitizeNestedItems(step.sub_steps_attributes),
    step_participants_attributes: sanitizeNestedItems(step.step_participants_attributes)
  };
}
